// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__i8Qa_","input":"styles_input__oMRpZ"};